import {createRouter, createWebHashHistory} from 'vue-router';
import { store } from './store';
import functions from "@/functions";
import config from "@/config";

const routes = [
    {
        path: '/',
        name: 'dashboard',
        exact: true,
        component: () => import('./components/appliances/Dashboard.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Dashboard' }],
        },
        beforeEnter: (to, from, next) => {
          let role = store.getters['userdata/role'];
          if(role) {
            if(role==='USER') {
              next();
            } else if(role.includes('SERVICE')) {
              next({ name: 'service' });
            } else if(role.includes('FACTORY') || role==='SUBSIDIARY' || role.includes('INTERNAL')) {
              next({ name: 'factory' });
            } else {
              next({ name: 'access' });
            }
          } else {
            next({ name: 'access' });
          }
        }
    },
    {
        path: '/appliance/:serialNumber',
        name: 'appliance-details',
        exact: true,
        component: () => import('./components/appliances/Details.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Details' }],
        },
    },
    // {
    //     path: '/test',
    //     name: 'test',
    //     exact: true,
    //     component: () => import('./components/misc/Test.vue'),
    //     meta: {
    //         breadcrumb: [{ parent: 'TEST', label: 'TEST' }],
    //     },
    // },
    {
        path: '/appliance/:serialNumber/mf-cycle',
        name: 'appliance-mf-cycle',
        exact: true,
        component: () => import('./components/appliances/mf/Cycle.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'MF Cycle' }],
        },
    },
    {
        path: '/appliance/:serialNumber/mf-cycle-def',
        name: 'appliance-mf-cycle-def',
        exact: true,
        component: () => import('./components/appliances/mf/Cycle_old.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'MF Cycle' }],
        },
    },
    // {
    //     path: '/appliance/:serialNumber/ef-cycle',
    //     name: 'appliance-ef-cycle',
    //     exact: true,
    //     component: () => import('./components/appliances/ef/Cycle.vue'),
    //     meta: {
    //         breadcrumb: [{ parent: 'Dashboard', label: 'EF Cycle' }],
    //     },
    // },
    {
        path: '/appliance/:serialNumber/ef-cycle-def',
        name: 'appliance-ef-cycle-def',
        exact: true,
        component: () => import('./components/appliances/ef/Cycle_old.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'EF Cycle' }],
        },
    },
    {
        path: '/appliance/:serialNumber/sf-cycle-def',
        name: 'appliance-sf-cycle-def',
        exact: true,
        component: () => import('./components/appliances/sf/Cycle_old.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'SF Cycle' }],
        },
    },
    {
        path: '/appliance/:serialNumber/cycles',
        name: 'appliance-cycles',
        exact: true,
        component: () => import('./components/misc/EmptyPage.vue'),
        meta: {
            breadcrumb: [{ parent: 'Appliance', label: 'Cycles' }],
        },
    },
    {
        path: '/account',
        name: 'account',
        exact: true,
        component: () => import('./components/account/Account.vue'),
        meta: {
            breadcrumb: [{ parent: 'Account', label: 'Account' }],
        },
    },
    {
        path: '/account/userinfo',
        name: 'userinfo',
        exact: true,
        component: () => import('./components/account/Userinfo.vue'),
        meta: {
            breadcrumb: [{ parent: 'Account', label: 'User Info' }],
        },
    },
    {
        path: '/account/company',
        name: 'company',
        exact: true,
        component: () => import('./components/account/Company.vue'),
        meta: {
            breadcrumb: [{ parent: 'Account', label: 'Company' }],
        },
        beforeEnter: (to, from, next) => {
          let role = store.getters['userdata/role'];
          if(role) {
            if(role==='USER' || role.includes('SERVICE')) {
              next();
            } else {
              next({ name: 'access' });
            }
          } else {
            next({ name: 'access' });
          }
        }
    },
    {
        path: '/account/laboratories',
        name: 'laboratories',
        exact: true,
        component: () => import('./components/account/Laboratories.vue'),
        meta: {
            breadcrumb: [{ parent: 'Account', label: 'Laboratories' }],
        },
        beforeEnter: (to, from, next) => {
          let role = store.getters['userdata/role'];
          if(role) {
            if(role==='USER') {
              next();
            } else {
              next({ name: 'access' });
            }
          } else {
            next({ name: 'access' });
          }
        }
    },
    {
        path: '/account/preferences',
        name: 'preferences',
        exact: true,
        component: () => import('./components/account/Preferences.vue'),
        meta: {
            breadcrumb: [{ parent: 'Account', label: 'Preferences' }],
        },
    },
    {
        path: '/analytics',
        name: 'analytics',
        exact: true,
        component: () => import('./components/analytics/AnalyticsRoot.vue'),
        meta: {
            breadcrumb: [{ parent: 'Analytics', label: 'Analytics' }],
        },
    },
    // {
    //     path: '/haccp',
    //     name: 'haccp',
    //     exact: true,
    //     component: () => import('./components/haccp/DeviceList.vue'),
    //     meta: {
    //         breadcrumb: [{ parent: 'HACCP', label: 'HACCP' }],
    //     },
    // },
    {
        path: '/haccp/:serialNumber',
        name: 'haccp-reports',
        exact: true,
        component: () => import('./components/haccp/Reports.vue'),
        meta: {
            historyback: false,
            breadcrumb: [{ parent: 'HACCP', label: 'Reports' }],
        },
    },
    {
        path: '/appliance/:serialNumber/analytics',
        name: 'appliance-analytics',
        exact: true,
        component: () => import('./components/analytics/ChartsList.vue'),
        meta: {
            historyback: true,
            breadcrumb: [{ parent: 'Appliance', label: 'Analytics' }],
        },
    },
    {
        path: '/laboratory/:labId/analytics',
        name: 'lab-analytics',
        exact: true,
        component: () => import('./components/analytics/ChartsList.vue'),
        meta: {
            historyback: true,
            breadcrumb: [{ parent: 'Analytics', label: 'Analytics' }],
        },
    },
    {
        path: '/appliance/:serialNumber/analytics-detail/:idChart-:chartType',
        name: 'appliance-analytics-detail',
        exact: true,
        component: () => import('./components/analytics/ChartDetail.vue'),
        meta: {
            historyback: true,
            breadcrumb: [{ parent: 'Appliance', label: 'Analytics' }],
        },
    },
    {
        path: '/laboratory/:labId/analytics-detail/:gamma-:idChart-:chartType',
        name: 'lab-analytics-detail',
        exact: true,
        component: () => import('./components/analytics/ChartDetail.vue'),
        meta: {
            historyback: true,
            breadcrumb: [{ parent: 'Analytics', label: 'Analytics' }],
        },
    },
    {
        path: '/appliance/:serialNumber/haccp',
        name: 'haccp-reports-historyback',
        exact: true,
        component: () => import('./components/haccp/Reports.vue'),
        meta: {
            historyback: true,
            breadcrumb: [{ parent: 'HACCP', label: 'Reports' }],
        },
    },
    {
        path: '/appliance/:serialNumber/energy',
        name: 'energy-details-historyback',
        exact: true,
        component: () => import('./components/energy/EnergyDetails.vue'),
        meta: {
            historyback: true,
            breadcrumb: [{ parent: 'Energy', label: 'Energy' }],
        },
    },
    {
        path: '/appliance/:serialNumber/frevi',
        name: 'frevi-movements',
        exact: true,
        component: () => import('./components/frevi/FreviMovements.vue'),
        meta: {
            historyback: true,
            breadcrumb: [{ parent: 'FREVI', label: 'FREVI' }],
        },
    },
    {
        path: '/notifications',
        name: 'notifications',
        exact: true,
        component: () => {
          if(config.maintenanceEnabled()) {
            return import('./components/misc/Notifications.vue')
          } else {
            return import('./components/misc/Notifications_old.vue')
          }
        },
        meta: {
            breadcrumb: [{ parent: 'Notification', label: 'Notification' }],
        },
        beforeEnter: (to, from, next) => {
          let role = store.getters['userdata/role'];
          if(role) {
            if(role==='USER') {
              next();
            } else {
              next({ name: 'access' });
            }
          } else {
            next({ name: 'access' });
          }
        }
    },
    {
        path: '/admin',
        name: 'admin',
        exact: true,
        component: () => import('./components/admin/Admin.vue'),
        meta: {
            breadcrumb: [{ parent: 'Admin', label: 'Admin' }],
        },
        beforeEnter: (to, from, next) => {
          let role = store.getters['userdata/role'];
          if(role) {
            if(role==='USER') {
              next();
            } else {
              next({ name: 'access' });
            }
          } else {
            next({ name: 'access' });
          }
        }
    },
    {
        path: '/admin/user/:email',
        name: 'admin-user',
        exact: true,
        component: () => import('./components/admin/Appliances.vue'),
        meta: {
            breadcrumb: [{ parent: 'Admin', label: 'Appliances' }],
        },
        beforeEnter: (to, from, next) => {
          let role = store.getters['userdata/role'];
          if(role) {
            if(role==='USER') {
              next();
            } else {
              next({ name: 'access' });
            }
          } else {
            next({ name: 'access' });
          }
        }
    },
    {
        path: '/support',
        name: 'support',
        exact: true,
        component: () => import('./components/misc/Support.vue'),
        meta: {
            breadcrumb: [{ parent: 'Support', label: 'Support' }],
        },
        beforeEnter: (to, from, next) => {
          let role = store.getters['userdata/role'];
          if(role) {
            if(role==='USER' || role.includes('SERVICE')) {
              next();
            } else {
              next({ name: 'access' });
            }
          } else {
            next({ name: 'access' });
          }
        }
    },
    {
      path: '/ai-virtual-assistant',
      name: 'chatbot',
      exact: true,
      component: () => import('./components/misc/ChatBotFullPage.vue'),
      meta: {
          breadcrumb: [{ parent: 'Dashboard', label: 'ChatBot' }],
      },
      beforeEnter: (to, from, next) => {
        let role = store.getters['userdata/role'];
        if(!functions.isMobile()/* || config.currentEnv!="dev"*/) {
          if(role) {
            if(role==='USER') {
              next({ name: 'dashboard' });
            } else if(role.includes('SERVICE')) {
              next({ name: 'service' });
            } else if(role.includes('FACTORY') || role==='SUBSIDIARY'  || role.includes('INTERNAL')) {
              next({ name: 'factory' });
            } else {
              next({ name: 'access' });
            }
          } else {
            next({ name: 'access' });
          }
        } else {
          if(config.isChatbotEnabled(store.getters['userdata/chatbot'])) {
            next();
          } else {
            next({ name: 'access' });
          }
        }
      }
    },
    {
      path: '/factory',
      name: 'factory',
      exact: true,
      component: () => import('./components/factory/Factory.vue'),
      meta: {
          breadcrumb: [{ parent: 'Dashboard', label: 'Factory' }],
      },
      beforeEnter: (to, from, next) => {
        let role = store.getters['userdata/role'];
        if(role) {
          if(role.includes('FACTORY') || role==='SUBSIDIARY' || role.includes('INTERNAL')) {
            next();
          } else {
            next({ name: 'access' });
          }
        } else {
          next({ name: 'access' });
        }
      }
    },
    {
      path: '/factory/user/:encryptedEmailRole',
      name: 'factory-user',
      exact: true,
      component: () => import('./components/factory/FactoryUser.vue'),
      meta: {
          breadcrumb: [{ parent: 'Factory', label: 'User' }],
      },
      beforeEnter: (to, from, next) => {
        let role = store.getters['userdata/role'];
        if(role) {
          if(role.includes('FACTORY') || role==='SUBSIDIARY' || role.includes('INTERNAL')) {
            next();
          } else {
            next({ name: 'access' });
          }
        } else {
          next({ name: 'access' });
        }
      }
    },
    {
      path: '/factory/appliance/:serialNumber',
      name: 'factory-appliance',
      exact: true,
      component: () => import('./components/factory/FactoryAppliance.vue'),
      meta: {
          breadcrumb: [{ parent: 'Factory', label: 'Appliance' }],
      },
      beforeEnter: (to, from, next) => {
        let role = store.getters['userdata/role'];
        if(role) {
          if(role.includes('FACTORY') || role==='SUBSIDIARY' || role.includes('INTERNAL')) {
            next();
          } else {
            next({ name: 'access' });
          }
        } else {
          next({ name: 'access' });
        }
      }
    },
    {
      path: '/service',
      name: 'service',
      exact: true,
      component: () => import('./components/service/Service.vue'),
      meta: {
          breadcrumb: [{ parent: 'Dashboard', label: 'Service' }],
      },
      beforeEnter: (to, from, next) => {
        let role = store.getters['userdata/role'];
        if(role) {
          if(role.includes('SERVICE')) {
            next();
          } else {
            next({ name: 'access' });
          }
        } else {
          next({ name: 'access' });
        }
      }
    },
    {
      path: '/fota',
      name: 'fota',
      exact: true,
      component: () => import('./components/misc/Fota.vue'),
      meta: {
          breadcrumb: [{ parent: 'FOTA', label: 'FOTA' }],
      },
      beforeEnter: (to, from, next) => {
        let role = store.getters['userdata/role'];
        if(role) {
          if(role.includes('FACTORY')) {
            next();
          } else {
            next({ name: 'access' });
          }
        } else {
          next({ name: 'access' });
        }
      }
    },
    {
      path: '/faq',
      name: 'faq',
      exact: true,
      component: () => import('./components/misc/Faq.vue'),
      meta: {
          breadcrumb: [{ parent: 'FAQ', label: 'FAQ' }],
      },
      beforeEnter: (to, from, next) => {
        let role = store.getters['userdata/role'];
        if(role) {
          if(role==='USER' || role.includes('SERVICE')) {
            next();
          } else {
            next({ name: 'access' });
          }
        } else {
          next({ name: 'access' });
        }
      }
    },
    // LIBRARY
    {
      path: '/library',
      name: 'library',
      exact: true,
      component: () => import('./components/library/LibraryWeb.vue'),
      meta: {
      },
      beforeEnter: (to, from, next) => {
        let role = store.getters['userdata/role'];
        if(role) {
          if(role==='USER') {
            next();
          } else {
            next({ name: 'access' });
          }
        } else {
          next({ name: 'access' });
        }
      }
    },
    {
      path: '/appliance/:serialNumber/library',
      name: 'appliance-library',
      exact: true,
      component: () => import('./components/library/LibraryAppliance.vue'),
      meta: {
      },
      beforeEnter: (to, from, next) => {
        let role = store.getters['userdata/role'];
        if(role) {
          if(role==='USER' || role.includes('SERVICE') || role==='SUBSIDIARY' || role.includes('FACTORY')) {
            next();
          } else {
            next({ name: 'access' });
          }
        } else {
          next({ name: 'access' });
        }
      }
    },
    // CYCLE OVERVIEW
    {
      path: '/library/cycle/:recipeId',
      name: 'recipe-overview',
      exact: true,
      component: () => import('./components/library/overview/RecipeOverview.vue'),
      meta: {
      },
      beforeEnter: (to, from, next) => {
        let role = store.getters['userdata/role'];
        if(role) {
          if(role==='USER' || role.includes('SERVICE') || role==='SUBSIDIARY' || role.includes('FACTORY')) {
            next();
          } else {
            next({ name: 'access' });
          }
        } else {
          next({ name: 'access' });
        }
      }
    },
    {
      path: '/appliance/:serialNumber/library/cycle/:recipeId',
      name: 'appliance-recipe-overview',
      exact: true,
      component: () => import('./components/library/overview/RecipeOverview.vue'),
      meta: {
      },
      beforeEnter: (to, from, next) => {
        let role = store.getters['userdata/role'];
        if(role) {
          if(role==='USER' || role.includes('SERVICE') || role==='SUBSIDIARY' || role.includes('FACTORY')) {
            next();
          } else {
            next({ name: 'access' });
          }
        } else {
          next({ name: 'access' });
        }
      }
    },
    // CREATE NEW CYCLE
    {
      path: '/library/create-cycle/:function',
      name: 'recipe-create',
      exact: true,
      component: () => import('./components/library/editing/RecipeEditing.vue'),
      meta: {
      },
      beforeEnter: (to, from, next) => {
        let role = store.getters['userdata/role'];
        if(role) {
          if(role==='USER') {
            next();
          } else {
            next({ name: 'access' });
          }
        } else {
          next({ name: 'access' });
        }
      }
    },
    {
      path: '/appliance/:serialNumber/library/create-cycle/:function',
      name: 'appliance-recipe-create',
      exact: true,
      component: () => import('./components/library/editing/RecipeEditing.vue'),
      meta: {
      },
      beforeEnter: (to, from, next) => {
        let role = store.getters['userdata/role'];
        if(role) {
          if(role==='USER') {
            next();
          } else {
            next({ name: 'access' });
          }
        } else {
          next({ name: 'access' });
        }
      }
    },
    // EDIT CYCLE
    {
      path: '/library/cycle/:recipeId/edit',
      name: 'recipe-edit',
      exact: true,
      component: () => import('./components/library/editing/RecipeEditing.vue'),
      meta: {
      },
      beforeEnter: (to, from, next) => {
        let role = store.getters['userdata/role'];
        if(role) {
          if(role==='USER') {
            next();
          } else {
            next({ name: 'access' });
          }
        } else {
          next({ name: 'access' });
        }
      }
    },
    {
      path: '/appliance/:serialNumber/library/cycle/:recipeId/edit',
      name: 'appliance-recipe-edit',
      exact: true,
      component: () => import('./components/library/editing/RecipeEditing.vue'),
      meta: {
      },
      beforeEnter: (to, from, next) => {
        let role = store.getters['userdata/role'];
        if(role) {
          if(role==='USER') {
            next();
          } else {
            next({ name: 'access' });
          }
        } else {
          next({ name: 'access' });
        }
      }
    },
    // {
    //   path: '/cycles',
    //   name: 'cycles',
    //   exact: true,
    //   component: () => import('./components/misc/EmptyPage.vue'),
    //   meta: {
    //       breadcrumb: [{ parent: 'Cycles', label: 'Cycles' }],
    //   },
    //   beforeEnter: (to, from, next) => {
    //     let role = store.getters['userdata/role'];
    //     if(role) {
    //       if(role==='USER') {
    //         next();
    //       } else {
    //         next({ name: 'access' });
    //       }
    //     } else {
    //       next({ name: 'access' });
    //     }
    //   }
    // },
    {
      path: '/report',
      name: 'report',
      exact: true,
      component: () => import('./components/report/ReportList.vue'),
      meta: {
          breadcrumb: [{ parent: 'Report', label: 'Report' }],
      },
      beforeEnter: (to, from, next) => {
        let role = store.getters['userdata/role'];
        if(role) {
          if(role.includes('FACTORY') || role==='SUBSIDIARY' || role.includes('SERVICE') || role.includes('INTERNAL')) {
            next();
          } else {
            next({ name: 'access' });
          }
        } else {
          next({ name: 'access' });
        }
      }
    },
    {
      path: '/report/new',
      name: 'report-new',
      exact: true,
      component: () => import('./components/report/Report.vue'),
      meta: {
          breadcrumb: [{ parent: 'Report', label: 'Report' }],
      },
      beforeEnter: (to, from, next) => {
        let role = store.getters['userdata/role'];
        if(role) {
          if(role.includes('FACTORY') || role.includes('SERVICE') || role==='SUBSIDIARY') {
            next();
          } else {
            next({ name: 'access' });
          }
        } else {
          next({ name: 'access' });
        }
      }
    },
    {
      path: '/report/:serialNumber/:reportId',
      name: 'report-edit',
      exact: true,
      component: () => import('./components/report/Report.vue'),
      meta: {
          breadcrumb: [{ parent: 'Report', label: 'Report' }],
      },
      beforeEnter: (to, from, next) => {
        let role = store.getters['userdata/role'];
        if(role) {
          if(role.includes('FACTORY') || role==='SUBSIDIARY' || role.includes('SERVICE') || role.includes('INTERNAL')) {
            next();
          } else {
            next({ name: 'access' });
          }
        } else {
          next({ name: 'access' });
        }
      }
    },
    {
      path: '/accessibility',
      name: 'accessibility',
      exact: true,
      component: () => import('./components/misc/Accessibility.vue'),
      meta: {
          breadcrumb: [{ parent: 'Accessibility', label: 'Accessibility' }],
      },
    },
    {
        path: '/energy',
        name: 'energy',
        exact: true,
        component: () => import('./components/energy/Energy.vue'),
        meta: {
            breadcrumb: [{ parent: 'Energy', label: 'Energy' }],
        },
    },
    {
        path: '/energy/:serialNumber',
        name: 'energy-details',
        exact: true,
        component: () => import('./components/energy/EnergyDetails.vue'),
        meta: {
            historyback: false,
            breadcrumb: [{ parent: 'Energy', label: 'Energy Details' }],
        },
    },
    {
        path: '/after-sales',
        name: 'after-sales',
        exact: true,
        component: () => import('./components/afterSales/AfterSales.vue'),
        meta: {
            breadcrumb: [{ parent: 'After Sales', label: 'After Sales' }],
        },
    },
    {
        path: '/after-sales/tree/:docTreeId',
        name: 'after-sales-tree',
        exact: true,
        component: () => import('./components/afterSales/ModelDetails.vue'),
        meta: {
            breadcrumb: [{ parent: 'After Sales - Model Details', label: 'After Sales - Model Details' }],
        },
    },
    {
        path: '/after-sales/model/:modelId/:modelDomain',
        name: 'after-sales-model',
        exact: true,
        component: () => import('./components/afterSales/ModelDetails.vue'),
        meta: {
            breadcrumb: [{ parent: 'After Sales - Model Details', label: 'After Sales - Model Details' }],
        },
    },
    {
        path: '/after-sales/tree/:docTreeId/spare-parts/:table',
        name: 'after-sales-spare-parts',
        exact: true,
        component: () => import('./components/afterSales/spareParts/SpareParts.vue'),
        meta: {
            breadcrumb: [{ parent: 'After Sales - Spare Parts', label: 'After Sales - Model Spare Parts' }],
        },
    },
    {
        path: '/after-sales/upload-document',
        name: 'after-sales-upload-document',
        exact: true,
        component: () => import('./components/afterSales/UploadDocument.vue'),
        meta: {
            breadcrumb: [{ parent: 'After Sales - Upload Document', label: 'After Sales - Upload Document' }],
        },
        beforeEnter: (to, from, next) => {
          let role = store.getters['userdata/role'];
          if(role) {
            if(role==='INTERNAL_DOC' || role==='SUPERFACTORY') {
              next();
            } else {
              next({ name: 'access' });
            }
          } else {
            next({ name: 'access' });
          }
        }
    },
    {
        path: '/after-sales/exploded',
        name: 'after-sales-exploded',
        exact: true,
        component: () => import('./components/afterSales/spareParts/UploadExploded.vue'),
        meta: {
            breadcrumb: [{ parent: 'After Sales - Upload Exploded', label: 'After Sales - Upload Exploded' }],
        },
        beforeEnter: (to, from, next) => {
          let role = store.getters['userdata/role'];
          if(role) {
            if(role==='INTERNAL_DOC' || role==='SUPERFACTORY') {
              next();
            } else {
              next({ name: 'access' });
            }
          } else {
            next({ name: 'access' });
          }
        }
    },
    {
        path: '/after-sales/catalogue',
        name: 'after-sales-catalogue',
        exact: true,
        component: () => import('./components/afterSales/spareParts/Catalogue.vue'),
        meta: {
            breadcrumb: [{ parent: 'After Sales - Catalogue', label: 'After Sales - Catalogue' }],
        },
        beforeEnter: (to, from, next) => {
          let role = store.getters['userdata/role'];
          if(role) {
            if(role==='INTERNAL_DOC' || role==='SUPERFACTORY') {
              next();
            } else {
              next({ name: 'access' });
            }
          } else {
            next({ name: 'access' });
          }
        }
    },
    {
        path: '/after-sales/favorites',
        name: 'after-sales-favorites',
        exact: true,
        component: () => import('./components/afterSales/Favorites.vue'),
        meta: {
            breadcrumb: [{ parent: 'After Sales - Favorites', label: 'After Sales - Favorites' }],
        },
    },
    {
        path: '/after-sales/search-product',
        name: 'after-sales-search-product',
        exact: true,
        component: () => import('./components/afterSales/SearchProduct.vue'),
        meta: {
            breadcrumb: [{ parent: 'After Sales - Search Product', label: 'After Sales - Search Product' }],
        },
    },
    {
        path: '/after-sales/search-document',
        name: 'after-sales-search-document',
        exact: true,
        component: () => import('./components/afterSales/SearchDocument.vue'),
        meta: {
            breadcrumb: [{ parent: 'After Sales - Search Document', label: 'After Sales - Search Document' }],
        },
    },
    {
        path: '/after-sales/search-serial',
        name: 'after-sales-search-serial',
        exact: true,
        component: () => import('./components/afterSales/SearchSerial.vue'),
        meta: {
            breadcrumb: [{ parent: 'After Sales - Search Serial', label: 'After Sales - Search Serial' }],
        },
    },
    {
        path: '/after-sales/search-serial/bom/:serialNumber-:productCode',
        name: 'after-sales-search-serial-bom',
        exact: true,
        component: () => import('./components/afterSales/SearchSerialBom.vue'),
        meta: {
            breadcrumb: [{ parent: 'After Sales - Search Serial BOM', label: 'After Sales - Search Serial BOM' }],
        },
    },
    {
        path: '/after-sales/shopping-cart',
        name: 'after-sales-shopping-cart',
        exact: true,
        component: () => import('./components/afterSales/spareParts/ShoppingCart.vue'),
        meta: {
            breadcrumb: [{ parent: 'After Sales - Shopping Cart', label: 'After Sales - Shopping Cart' }],
        },
        beforeEnter: (to, from, next) => {
          let role = store.getters['userdata/role'];
          if(role) {
            if(role!=='USER') {
              next();
            } else {
              next({ name: 'access' });
            }
          } else {
            next({ name: 'access' });
          }
        }
    },
    {
        path: '/after-sales/orders',
        name: 'after-sales-orders',
        exact: true,
        component: () => import('./components/afterSales/spareParts/Orders.vue'),
        meta: {
            breadcrumb: [{ parent: 'After Sales - Orders', label: 'After Sales - Orders' }],
        },
        beforeEnter: (to, from, next) => {
          let role = store.getters['userdata/role'];
          if(role) {
            if(role!=='USER') {
              next();
            } else {
              next({ name: 'access' });
            }
          } else {
            next({ name: 'access' });
          }
        }
    },
    {
        path: '/checkout/success',
        name: 'checkout-success',
        exact: true,
        component: () => import('./components/admin/checkout/CheckoutSuccess.vue'),
        meta: {
            breadcrumb: [{ parent: 'Checkout Success', label: 'Checkout Success' }],
        },
        beforeEnter: (to, from, next) => {
          let role = store.getters['userdata/role'];
          if(role) {
            if(role=='USER') {
              next();
            } else {
              next({ name: 'access' });
            }
          } else {
            next({ name: 'access' });
          }
        }
    },
    {
        path: '/checkout/cancel',
        name: 'checkout-cancel',
        exact: true,
        component: () => import('./components/admin/checkout/CheckoutCancel.vue'),
        meta: {
            breadcrumb: [{ parent: 'Checkout Cancel', label: 'Checkout Cancel' }],
        },
        beforeEnter: (to, from, next) => {
          let role = store.getters['userdata/role'];
          if(role) {
            if(role=='USER') {
              next();
            } else {
              next({ name: 'access' });
            }
          } else {
            next({ name: 'access' });
          }
        }
    },
    // {
    //     path: '/digital-warehouse',
    //     name: 'digital-warehouse',
    //     exact: true,
    //     component: () => import('./components/warehouse/DigitalWarehouse.vue'),
    //     meta: {
    //         breadcrumb: [{ parent: 'Digital Warehouse', label: 'Digital Warehouse' }],
    //     },
    //     beforeEnter: (to, from, next) => {
    //       let role = store.getters['userdata/role'];
    //       if(role) {
    //         if(role==='USER') {
    //           next();
    //         } else {
    //           next({ name: 'access' });
    //         }
    //       } else {
    //         next({ name: 'access' });
    //       }
    //     }
    // },
    // {
    //     path: '/digital-warehouse/ice-cream/:serialNumber',
    //     name: 'digital-warehouse-ice-cream',
    //     exact: true,
    //     component: () => import('./components/warehouse/DigitalWarehouseIceCream.vue'),
    //     meta: {
    //         breadcrumb: [{ parent: 'Digital Warehouse', label: 'Digital Warehouse - Ice Cream' }],
    //     },
    //     beforeEnter: (to, from, next) => {
    //       let role = store.getters['userdata/role'];
    //       if(role) {
    //         if(role==='USER') {
    //           next();
    //         } else {
    //           next({ name: 'access' });
    //         }
    //       } else {
    //         next({ name: 'access' });
    //       }
    //     }
    // },
    // {
    //     path: '/digital-warehouse/pastry/:serialNumber',
    //     name: 'digital-warehouse-pastry',
    //     exact: true,
    //     component: () => import('./components/warehouse/DigitalWarehousePastry.vue'),
    //     meta: {
    //         breadcrumb: [{ parent: 'Digital Warehouse', label: 'Digital Warehouse - Pastry' }],
    //     },
    //     beforeEnter: (to, from, next) => {
    //       let role = store.getters['userdata/role'];
    //       if(role) {
    //         if(role==='USER') {
    //           next();
    //         } else {
    //           next({ name: 'access' });
    //         }
    //       } else {
    //         next({ name: 'access' });
    //       }
    //     }
    // },
    { 
        path: '/:pathMatch(.*)*', 
        name: 'not-found', 
        component: () => import('./pages/NotFound.vue'),
        meta: {
          breadcrumb: [{ parent: 'Not Found', label: 'Not Found' }],
        },
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('./pages/Login.vue')
    },
    {
        path: '/error',
        name: 'error',
        component: () => import('./pages/Error.vue')
    },
    {
        path: '/notfound',
        name: 'notfound',
        component: () => import('./pages/NotFound.vue')
    },
    {
        path: '/access',
        name: 'access',
        component: () => import('./pages/Access.vue'),
        meta: {
          breadcrumb: [{ parent: 'Access', label: 'Access' }],
        },
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior () {
        return { left: 0, top: 0 };
    }
});

export default router;